<template>
  <div class="usernav">
    <div class="w12 between">
      <div class="flex_start">
        <div class="logo">
          <img src="../../../assets/base/logo_sample.png" alt="" />
        </div>
        <div class="hyy">{{ navtxt }}</div>
      </div>
      <div>
        <ul class="usernavlist flex_start">
          <li @click="tojump('/')">首页</li>
          <li @click="tojump('/question/lawyeronline')">问律师</li>
          <li @click="tojump('/findLawyers')">找律师</li>
          <li @click="tojump('/laws')">查知识</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    navtxt() {
      return this.$store.state.user.lognavtxt;
    },
  },
  methods: {
    tojump(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="scss" scoped>
.usernav {
  background: #ffffff;
  box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.09);
  .w12 {
    width: 1200px;
    margin: 0 auto;
    height: 90px;
  }
  .logo {
    margin-right: 44px;
    img {
      width: 145px;
    }
  }
  .hyy {
    font-size: 24px;
    color: #333333;
  }
  .usernavlist {
    li {
      cursor: pointer;
      margin-left: 25px;
      font-size: 14px;
      color: #333333;
      &:hover {
        color: #0465ea;
      }
    }
  }
}
</style>